const e="undefined"!=typeof window;export{e as isBrowser};
